import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Grid, IconButton, Paper, Stack, Typography } from '@mui/material';
import AIMaturityAssessment from './aIInventory/AIMaturityAssessmentCard';
import AIInventoryCard from './aIInventory/AIInventoryCard';
import { DashboardService } from 'services/DashboardService';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Vulnerability from './vulnerability/Vulnerability';
import AIInventory from './aIInventory/AIInventory';
import AIRiskManagement from 'modules/dashboard/overview/components/AIRiskManagementCard';
// import PolicyDataset from '../policyDataset/PolicyDataset';
import { useNavigate } from 'react-router-dom';
import RiskOverview from './riskOverview/RiskOverview';
import TrainingManagement from './trainingManagement/TrainingManagement';
import ExternalAssessments from './externalAssessments/ExternalAssessments';
import PolicyManagement from './policyManagement/PolicyManagement';
import ComplianceTracking from './complianceTracking/ComplianceTracking';

const Overview = (): ReactElement => {
  const navigate = useNavigate();
  const [dataOverview, setDataOverview] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    DashboardService.getDashboardOverview()
      .then((response) => {
        const { data } = response.data;

        setDataOverview(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <Box>
      <Box className="overview-page">
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={12} md={8}>
            <AIMaturityAssessment minimize={false} />
          </Grid>

          <Grid item xs={12} md={4}>
            <AIInventoryCard
              totalSystems={dataOverview?.aiSystems?.total || 0}
              pendingApprovement={dataOverview?.aiSystems?.pendingApproval || 0}
              highRiskSystems={dataOverview?.aiSystems?.highRisk || 0}
              totalDatasets={dataOverview?.datasets?.total || 0}
              sensitiveData={dataOverview?.datasets?.sensitive || 0}
              pendingReview={dataOverview?.datasets?.pendingReview || 0}
              isLoadingRecords={isLoading}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={4} sx={{ display: 'flex' }}>
            <Box
              sx={{
                display: 'grid',
                gap: 2,
                width: '100%',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: '1fr 1fr',
                  md: '1fr 1fr',
                  lg: '1fr',
                },
                gridAutoRows: '1fr',
                '& > *': { height: '100%' },
              }}
            >
              <AIInventory />
              <ComplianceTracking />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={8} sx={{ display: 'flex' }}>
            <Paper variant="outlined" sx={{ p: 2, width: '100%' }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="h5">Vulnerability Dashboard</Typography>

                <IconButton
                  onClick={() => {
                    navigate('/vulnerabilities');
                  }}
                >
                  <RemoveRedEyeIcon />
                </IconButton>
              </Stack>

              <Vulnerability />
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <TrainingManagement />
          </Grid>
          <Grid item xs={12} md={4}>
            <PolicyManagement />
          </Grid>
          <Grid item xs={12} md={4}>
            <ExternalAssessments />
          </Grid>

          <Grid item xs={12} className="risk-management">
            <RiskOverview />
          </Grid>
          <Grid item xs={12} className="risk-management">
            <AIRiskManagement />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Overview;
